// **** import modules ****
import $ from "jquery";
import app, { vuwer, csl } from "@@assets/scripts/common";
import "./_pageHeader";
import "./_news";


// **** process ****
vuwer.setProp({
	onReadyLast($self) {
		const $cmsArea = $("#cms_area");
		const fbArea = vuwer.get("fbArea");
		if(
			$cmsArea &&
			fbArea && fbArea.$self
		) {
			const h = $cmsArea.height() - $(".area-title").height();
			return fbArea.setState({ h });
		}
	}
});


app.onReady((...args) => {
	csl.log.orange(`${app.pageName} onReady`, ...args);
});

app.exec();
